import store from "../store";

const getMyRoles = () => {
  return store.getters["usersModule/getMyPermissions"];
};

export default {
  getMyRoles,
};
